import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Heading from '../../Atoms/Heading/Heading';
import './LegalCopy.scss';

interface LegalCopyProps {
  apiData: any;
}

const LegalCopy: React.FC<LegalCopyProps> = ({ apiData }) => {
  const navigationSections = _get(apiData, ['navigationSections'], []);

  return (
    <>
      {!_isEmpty(navigationSections) && (
        <Heading
          level="p"
          className="legal-copy__footer"
          title={_get(navigationSections, ['0', 'navigationSectionItems', '0', 'alternateText'])}
        />
      )}
    </>
  );
};

export default LegalCopy;
